// Show date in DD/MM/YYYY format
export const dateDDMMYYYY = (date: Date): string => {
  const day = date.getDate().toString().padStart(2, '0')
  const month = (date.getMonth() + 1).toString().padStart(2, '0')
  const year = date.getFullYear().toString()

  return `${day}/${month}/${year}`
}

export const isoDateToDDMM = (isoDate: string): string => {
  const [, month, day] = isoDate.split('-')
  return `${day}/${month}`
}

export const formatPlanningWeekLabel = ({
  weekNumber,
  year,
  dateStart,
  dateEnd,
}: {
  weekNumber: number
  year: number
  dateStart: string
  dateEnd: string
}): string =>
  `S${String(weekNumber).padStart(2, '0')} ${year} (${isoDateToDDMM(dateStart)} au ${isoDateToDDMM(dateEnd)})`
